export const setObjectValuesToBoolean = (obj, valueToSet) =>
  Object.fromEntries(Object.keys(obj).map(key => [key, valueToSet]));
